import React, { lazy } from "react";
import DashboardLayout from "layout/LayoutContainers/DashboardLayout";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import GppMaybeIcon from "@mui/icons-material/GppMaybe";
import DoneAllIcon from "@mui/icons-material/DoneAll";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import AirplanemodeActiveIcon from "@mui/icons-material/AirplanemodeActive";
import AirplanemodeInactiveIcon from "@mui/icons-material/AirplanemodeInactive";
import LogoutIcon from "@mui/icons-material/Logout";
import TimelineIcon from "@mui/icons-material/Timeline";
import LocationChipTitle from "components/Common/LocationChipTitle";

const ApplicationList = lazy(() => import("components/Dashboard/Applications/ApplicationList"));
const ViewApplication = lazy(() => import("components/Dashboard/Applications/ViewApplication"));
const DigitalPassList = lazy(() => import("components/Dashboard/Digital Passes/DigitalPassList"));
const ViewDigitalPass = lazy(() => import("components/Dashboard/Digital Passes/ViewDigitalPass"));
const AllEvents = lazy(() => import("components/Dashboard/MAGEvents/Allevents"));
const Logout = lazy(() => import("components/Auth/Logout"));

const terminalPortPoliceRoutes = [
  {
    type: "custom",
    key: "location-chip",
    component: <LocationChipTitle />,
  },
  { type: "divider", key: "divider-0" },
  {
    type: "title",
    title: "Applications",
    key: "applications-title",
  },
  {
    type: "collapse",
    name: "Applications",
    key: "applications",
    icon: <FormatListBulletedIcon />,
    collapse: [
      {
        name: "All Applications",
        key: "all",
        route: "/applications/all",
        component: (
          <DashboardLayout>
            <ApplicationList key="all" type="all" />
          </DashboardLayout>
        ),
        icon: <FormatListBulletedIcon />,
        noCollapse: true,
      },
      {
        name: "New Applications",
        key: "new",
        route: "/applications/new",
        component: (
          <DashboardLayout>
            <ApplicationList key="new" type="new" />
          </DashboardLayout>
        ),
        icon: <CircleNotificationsIcon />,
        noCollapse: true,
      },
      {
        name: "Approved",
        key: "approved",
        route: "/applications/approve",
        component: (
          <DashboardLayout>
            <ApplicationList key="approve" type="approve" />
          </DashboardLayout>
        ),
        icon: <CheckCircleOutlineIcon />,
        noCollapse: true,
      },
      {
        name: "Rejected",
        key: "rejected",
        route: "/applications/rejected",
        component: (
          <DashboardLayout>
            <ApplicationList key="rejected" type="rejected" />
          </DashboardLayout>
        ),
        icon: <GppMaybeIcon />,
        noCollapse: true,
      },
      {
        name: "Completed",
        key: "completed",
        route: "/applications/completed",
        component: (
          <DashboardLayout>
            <ApplicationList key="completed" type="completed" />
          </DashboardLayout>
        ),
        icon: <DoneAllIcon />,
        noCollapse: true,
      },
    ],
  },
  {
    type: null,
    route: "/applications/:id",
    key: "/applications/:id",
    component: (
      <DashboardLayout>
        <ViewApplication />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-1" },
  {
    type: "title",
    title: "Digital Portpass",
    key: "digitalpass-title",
  },
  {
    type: "collapse",
    name: "Digital Passes",
    key: "digitalpasses",
    icon: <FormatListBulletedIcon />,
    collapse: [
      {
        name: "All Digital Passes",
        key: "all",
        route: "/digitalpass/all",
        component: (
          <DashboardLayout>
            <DigitalPassList key="all" type="all" />
          </DashboardLayout>
        ),
        icon: <FormatListBulletedIcon />,
        noCollapse: true,
      },
      {
        name: "Active Passes",
        key: "active",
        route: "/digitalpass/active",
        component: (
          <DashboardLayout>
            <DigitalPassList key="active" type="active" />
          </DashboardLayout>
        ),
        icon: <AirplanemodeActiveIcon />,
        noCollapse: true,
      },
      {
        name: "Inactive Passes",
        key: "inactive",
        route: "/digitalpass/inactive",
        component: (
          <DashboardLayout>
            <DigitalPassList key="inactive" type="inactive" />
          </DashboardLayout>
        ),
        icon: <AirplanemodeInactiveIcon />,
        noCollapse: true,
      },
      {
        name: "Expired Passes",
        key: "expired",
        route: "/digitalpass/expired",
        component: (
          <DashboardLayout>
            <DigitalPassList key="expired" type="expired" />
          </DashboardLayout>
        ),
        icon: <GppMaybeIcon />,
        noCollapse: true,
      },
    ],
  },
  {
    type: null,
    route: "/digitalpass/:_id",
    key: "/digitalpass/:_id",
    component: (
      <DashboardLayout>
        <ViewDigitalPass />
      </DashboardLayout>
    ),
  },
  { type: "divider", key: "divider-2" },
  {
    type: "title",
    title: "MAG Events",
    key: "events-pages",
  },
  {
    type: "collapse",
    name: "Gate Events",
    key: "/events/penangport/all",
    route: "/events/penangport/all",
    component: (
      <DashboardLayout>
        <AllEvents key="penangport" type="penangport" />
      </DashboardLayout>
    ),
    icon: <TimelineIcon />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-gate-events" },
  {
    type: "title",
    title: "Profile",
    key: "profile-title",
  },
  {
    type: "collapse",
    route: "/auth/logout",
    name: "Logout",
    key: "logout",
    icon: <LogoutIcon />,
    component: <Logout />,
    noCollapse: true,
  },
  { type: "divider", key: "divider-3" },
];

export default terminalPortPoliceRoutes;

